// src/hooks/usePageContent.js
import { useState } from 'react';
import { getInvoiceByUser, updateInvoice } from '../services/paymentService';

const useInvoice = () => {
    const [status, setStatus] = useState('idle'); // idle | loading | done | error
    const [statusUpdate, setStatusUpdate] = useState('idle'); // idle | loading | done | error
    const [error, setError] = useState('');
    const [errorUpdate, setErrorUpdate] = useState('');
    const [data, setData] = useState([]);

    const fetchInvoice = async (req) => {
        setStatus('loading');
        setError('');

        try {
            const response = await getInvoiceByUser(req);

            if (response?.status !== 'Error') {
                setData(response.data); // depending on API shape
                setStatus('done');
            } else {
                setStatus('error');
                setError(response?.message || 'Something went wrong');
            }
        } catch (err) {
            setStatus('error');
            setError(err?.message || 'Something went wrong');
        }
    };

    const updateInvoiceStatus = async (invoiceId, status) => {
        setStatusUpdate('loading');
        setErrorUpdate('');

        try {
            const response = await updateInvoice(invoiceId, status);

            if (response?.status !== 'Error') {
                //setData(response.data); // depending on API shape
                setStatusUpdate('done');
            } else {
                setStatusUpdate('error');
                setErrorUpdate(response?.message || 'Something went wrong');
            }
        } catch (err) {
            setStatusUpdate('error');
            setErrorUpdate(err?.message || 'Something went wrong');
        }
    };

    const resetStatus = () => {
        setStatus('idle');
        setStatusUpdate('idle');
        setError('');
        setErrorUpdate('');
    };

    return {
        fetchInvoice,
        updateInvoiceStatus,
        data,
        status,
        statusUpdate,
        error,
        errorUpdate,
        resetStatus
    };
};

export default useInvoice;
